module.exports = __webpack_public_path__ + "static/media/expired.b832d7eb.svg";